import { Toaster as SonnerToaster } from 'sonner';

export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        style: {
          borderRadius: '12px',
          border: '1px solid var(--border, #e5e7eb)',
          boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        },
      }}
    />
  );
}
